/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * One selectable filter value with its current candidate count.
 */
export interface PipelineFilterFacet {
  value: string;
  label: string;
  /** @minimum 0 */
  count: number;
}
